module.exports = "<app-header-nav></app-header-nav>\n<!-- begin::Body -->\n<router-outlet></router-outlet>\n<!-- end:: Body -->\n"


//////////////////
// WEBPACK FOOTER
// /mnt/volume_sfo2_01/www/html/xpress-dev/src/app/theme/theme.component.html
// module id = ../../../../../src/app/theme/theme.component.html
// module chunks = main